import { OverlayModule } from '@angular/cdk/overlay'

import { ZardTooltipComponent, ZardTooltipDirective } from '@/styles/components/tooltip/tooltip'

export const ZardTooltipImports = [
    ZardTooltipComponent,
    ZardTooltipDirective,
    OverlayModule,
] as const
